import { accountIdFromPath } from "../util/accountId";
import authStore, {
    enterInspectFromEntry,
} from "./accessToken/observables/authStore";
import { authenticate } from "./auth";
import { getInspectToken } from "./inspectTokens";
import { getCognitoSession } from "./localStorage";

/**
 * Authenticate the base (logged-in) session, then resume inspect mode for this
 * tab if its `/:accountId` has a stored inspect token. Returns "app" to render
 * the app or "login" to show the login screen.
 */
export const bootstrapAuth = async (
    pathname: string,
): Promise<"app" | "login"> => {
    const baseSession = getCognitoSession();
    const authResult = await authenticate(baseSession);
    if (!authResult) {
        return "login";
    }

    authStore.dispatch("setAuthenticatedUser", { accountUser: authResult });

    const accountId = accountIdFromPath(pathname);
    if (accountId) {
        const entry = getInspectToken(accountId);
        if (entry) {
            await enterInspectFromEntry(accountId, entry);
        }
    }
    return "app";
};
